import {useMemo} from "react";
import {faUsers} from "@fortawesome/pro-light-svg-icons/faUsers";
import {faQuestion} from "@fortawesome/pro-light-svg-icons/faQuestion";
import {faShoppingCart} from "@fortawesome/pro-light-svg-icons/faShoppingCart";
import {faLuggageCart} from "@fortawesome/pro-light-svg-icons/faLuggageCart";
import {faClipboardList} from "@fortawesome/pro-light-svg-icons/faClipboardList";
import {faBorderAll} from "@fortawesome/pro-light-svg-icons/faBorderAll";
import {faCalculator} from "@fortawesome/pro-light-svg-icons/faCalculator";
import {faInventory} from "@fortawesome/pro-light-svg-icons/faInventory";
import {faAddressBook} from "@fortawesome/pro-light-svg-icons/faAddressBook";
import {faAddressCard} from "@fortawesome/pro-light-svg-icons/faAddressCard";
import {faWarehouseAlt} from "@fortawesome/pro-light-svg-icons/faWarehouseAlt";
import {faTruckMoving} from "@fortawesome/pro-light-svg-icons/faTruckMoving";
import {faAbacus} from "@fortawesome/pro-light-svg-icons/faAbacus";
import {faBoxUsd} from "@fortawesome/pro-light-svg-icons/faBoxUsd";
import {faUsersClass} from "@fortawesome/pro-light-svg-icons/faUsersClass";
import {faUserClock} from "@fortawesome/pro-light-svg-icons/faUserClock";
import {faCarSide} from "@fortawesome/pro-light-svg-icons/faCarSide";
import {faThList} from "@fortawesome/pro-light-svg-icons/faThList";
import {useUserInformation} from "../../../util/useUserInformation";
import {faFolderOpen} from "@fortawesome/pro-light-svg-icons/faFolderOpen";
import {faDatabase} from "@fortawesome/pro-light-svg-icons/faDatabase";
import {faGlobe} from "@fortawesome/pro-light-svg-icons/faGlobe";
import {faLocationCircle} from "@fortawesome/pro-light-svg-icons/faLocationCircle";
import {faServer} from "@fortawesome/pro-light-svg-icons/faServer";
import {faPhone} from "@fortawesome/pro-light-svg-icons/faPhone";
import {faTrash} from "@fortawesome/pro-light-svg-icons/faTrash";
import {faWindowRestore} from "@fortawesome/pro-light-svg-icons/faWindowRestore";
import {faSensorAlert} from "@fortawesome/pro-light-svg-icons/faSensorAlert";
import {faChartLine} from "@fortawesome/pro-light-svg-icons/faChartLine";
import {faPhoneAlt} from "@fortawesome/pro-light-svg-icons/faPhoneAlt";

export const useMenuItems = () => {
    const {
        hasAdminReadAccess,
        hasAudiologReadAccess,
        hasWarehouseWorkerReadAccess,
        hasStatsAdminReadAccess,
        hasCustomerContactReadAccess,
        hasNoRole,
        staffId,
        country,
    } = useUserInformation();

    return useMemo(
        () => ({
            menuItems: [
                ...(hasAdminReadAccess === true
                    ? [
                        {
                            label: "Overview",
                            icon: faBorderAll,
                            href: "/admin/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/admin/overview"),
                        },
                        // {
                        //   label: "News",
                        //   icon: faNewspaper,
                        //   href: "/admin/news",
                        //   isActive: (pathname: string) =>
                        //     pathname.startsWith("/admin/news"),
                        // },
                        {
                            label: "Reports",
                            icon: faClipboardList,
                            href: "/admin/reports",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/admin/reports"),
                        },
                        {
                            label: "Tid (admin)",
                            icon: faUserClock,
                            href: "/admin/time/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/admin/time"),
                        },
                        {
                            label: "Tid",
                            icon: faUserClock,
                            href: "/all/time/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/all/time"),
                        },
                        {
                            label: "Control",
                            icon: faThList,
                            href: "/mixed/customer-lists/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/mixed/customer-lists"),
                        },
                        {
                            label: "Kollegastatus",
                            icon: faUsers,
                            href: "/all/coworker-status",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/all/coworker-status"),
                        },
                        ...(country === "DK"
                            ? [
                                {
                                    label: "Calculator",
                                    icon: faCalculator,
                                    href: "/all/calculator",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/all/calculator"),
                                },
                            ]
                            : []),
                        ...(country === "DK"
                            ? [
                                {
                                    label: "Kundedata",
                                    icon: faServer,
                                    href: "/all/customer-data",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/all/customer-data"),
                                },
                            ]
                            : []),
                        // {
                        //   label: "Overtime & Leave",
                        //   icon: faUserClock,
                        //   href: "/admin/overtime",
                        //   isActive: (pathname: string) =>
                        //     pathname.startsWith("/admin/overtime/overview"),
                        // },
                        {
                            label: "Data",
                            icon: faDatabase,
                            href: "/mixed/data/overview",
                            target: "_blank",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/mixed/data"),
                        },
                        {
                            label: "Rapport",
                            icon: faChartLine,
                            href: "/mixed/stats/report",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/mixed/stats/report"),
                        },
                        ...(hasStatsAdminReadAccess
                            ? [
                                {
                                    label: "Rapport (admin)",
                                    icon: faChartLine,
                                    href: "/admin/stats/admin",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/admin/stats/admin"),
                                },
                            ]
                            : []),
                        {
                            label: "Kundekontakt",
                            icon: faPhoneAlt,
                            href: "/mixed/kundekontakt/oversigt",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/mixed/kundekontakt"),
                        },
                        {
                            label: "Ny Ordre",
                            icon: faShoppingCart,
                            href: "/audiologist/order/create-order",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/audiologist/order/create-order"),
                        },
                        {
                            label: "Mine Ordrer",
                            icon: faLuggageCart,
                            href: "/audiologist/order/order-list",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/audiologist/order/order-list"),
                        },
                        // {
                        //     label: "Documents",
                        //     icon: faFolderOpen,
                        //     href: "/admin/products",
                        //     isActive: (pathname: string) =>
                        //         pathname.startsWith("/admin/products"),
                        // },
                        {
                            label: "Dokumenter",
                            icon: faFolderOpen,
                            href: "/all/documents",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/all/documents"),
                        },
                        // {
                        //     label: "Links",
                        //     icon: faLink,
                        //     href: "/admin/links",
                        //     isActive: (pathname: string) =>
                        //         pathname.startsWith("/admin/links"),
                        // },
                        {
                            label: "FAQ",
                            icon: faQuestion,
                            href: "/admin/faqs",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/admin/faqs"),
                        },
                        {
                            label: "Users",
                            icon: faUsers,
                            href: "/admin/users",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/admin/users"),
                        },
                        ...(staffId === "01785a658c2000007e400021CCD6CDBC" // 01785a658c2000007e400021CCD6CDBC = MOR
                            ? [
                                {
                                    label: "Login As",
                                    icon: faUsers,
                                    href: "/admin/login-as/overview",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/admin/login-as"),
                                },
                            ]
                            : []),
                        {
                            label: "Kontakter (admin)",
                            icon: faAddressCard,
                            href: "/admin/contact-list",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/admin/contact-list"),
                        },
                        {
                            label: "Opslag",
                            icon: faWindowRestore,
                            href: "/mixed/bulletin-board/bulletin-list",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/mixed/bulletin-board"),
                        },
                        {
                            label: "Lager-notifikationer",
                            icon: faSensorAlert,
                            href: "/mixed/stock-notifications/stock-notifications-list",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/mixed/stock-notifications"),
                        },
                        // {
                        //     label: "Import Reports",
                        //     icon: faChartNetwork,
                        //     href: "/admin/amparex-import-reports",
                        //     isActive: (pathname: string) =>
                        //         pathname.startsWith("/admin/amparex-import-reports"),
                        // },
                    ]
                    : []),
                ...(hasAudiologReadAccess === true
                    ? [
                        {
                            label: "Overview",
                            icon: faBorderAll,
                            href: "/audiologist/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/audiologist/overview"),
                        },
                        {
                            label: "Reports",
                            icon: faClipboardList,
                            href: "/audiologist/reports",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/audiologist/reports"),
                        },
                        ...(country === "DK"
                            ? [
                                {
                                    label: "Calculator",
                                    icon: faCalculator,
                                    href: "/all/calculator",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/all/calculator"),
                                },
                            ]
                            : []),
                        ...(country === "DK"
                            ? [
                                {
                                    label: "Kundedata",
                                    icon: faServer,
                                    href: "/all/customer-data",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/all/customer-data"),
                                },
                            ]
                            : []),
                        // {
                        //     label: "Overtime & Leave",
                        //     icon: faUserClock,
                        //     href: "/audiologist/overtime/overview",
                        //     isActive: (pathname: string) =>
                        //         pathname.startsWith("/audiologist/overtime"),
                        // },
                        {
                            label: "Tid",
                            icon: faUserClock,
                            href: "/all/time/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/all/time"),
                        },
                        {
                            label: "Ny Ordre",
                            icon: faShoppingCart,
                            href: "/audiologist/order/create-order",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/audiologist/order/create-order"),
                        },
                        {
                            label: "Mine Ordrer",
                            icon: faLuggageCart,
                            href: "/audiologist/order/order-list",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/audiologist/order/order-list"),
                        },
                        {
                            label: "Data",
                            icon: faDatabase,
                            href: "/mixed/data/overview",
                            target: "_blank",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/mixed/data"),
                        },
                        {
                            label: "Mit Lager",
                            icon: faInventory,
                            href: "/audiologist/stock/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/audiologist/stock/"),
                        },
                        {
                            label: "Kundekontakt",
                            icon: faPhoneAlt,
                            href: "/mixed/kundekontakt/oversigt",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/mixed/kundekontakt"),
                        },
                        {
                            label: "Rapport",
                            icon: faChartLine,
                            href: "/mixed/stats/report",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/mixed/stats/report"),
                        },
                        ...(hasStatsAdminReadAccess
                            ? [
                                {
                                    label: "Rapport (admin)",
                                    icon: faChartLine,
                                    href: "/admin/stats/admin",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/admin/stats/admin"),
                                },
                            ]
                            : []),
                        {
                            label: "GPS-Kort",
                            icon: faGlobe,
                            href: "/audiologist/gps/kort",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/audiologist/gps/kort"),
                        },
                        {
                            label: "GPS Actions",
                            icon: faLocationCircle,
                            href: "/audiologist/gps/actions",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/audiologist/gps/actions"),
                        },
                        // {
                        //     label: "Documents",
                        //     icon: faFolderOpen,
                        //     href: "/audiologist/products",
                        //     isActive: (pathname: string) =>
                        //         // pathname.startsWith("/audiologist/products"),
                        //         /\/audiologist\/products(?!\/my-orders)/.test(pathname),
                        // },
                        {
                            label: "Dokumenter",
                            icon: faFolderOpen,
                            href: "/all/documents",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/all/documents"),
                        },
                        // only show these, if we're not already showing them in the admin menu (for the office role)
                        ...(hasAdminReadAccess === false
                            ? [
                                {
                                    label: "Kollegastatus",
                                    icon: faUsers,
                                    href: "/all/coworker-status",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/all/coworker-status"),
                                },
                                // {
                                //     label: "Links",
                                //     icon: faLink,
                                //     href: "/audiologist/links",
                                //     isActive: (pathname: string) =>
                                //         pathname.startsWith("/audiologist/links"),
                                // },
                                {
                                    label: "Opslag",
                                    icon: faWindowRestore,
                                    href: "/mixed/bulletin-board/bulletin-list",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/mixed/bulletin-board"),
                                },
                                {
                                    label: "FAQ",
                                    icon: faQuestion,
                                    href: "/audiologist/faqs",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/audiologist/faqs"),
                                },
                            ]
                            : []),
                        {
                            label: "Lageroptælling",
                            icon: faAbacus,
                            href: "/audiologist/stock-statements/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/audiologist/stock-statements"),
                        },
                    ]
                    : []),
                // ...(hasAudiologReadAccess === true && staffId === "016737b3e7d900007437FC4596EFB594" // 016737b3e7d900007437FC4596EFB594 = Kristine Kjærsgaard ID: 101013 (DK)
                //     ? [
                //         {
                //             label: "Audiologist Stock",
                //             icon: faCarSide,
                //             href: "/audiologist/audiologist-stock/overview",
                //             isActive: (pathname: string) =>
                //                 pathname.startsWith("/audiologist/audiologist-stock/"),
                //         },
                //     ]
                //     : []),
                ...(hasAudiologReadAccess === true && ["016737b3e7d900007437FC4596EFB594", "01808ea773b800008f37806D971A7A40"].includes(staffId) // KK, SAN
                    ? [
                        {
                            label: "Stock²",
                            icon: faWarehouseAlt,
                            href: "/mixed/stock2/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/mixed/stock2"),
                        },
                    ]
                    : []),
                ...(hasWarehouseWorkerReadAccess === true
                    ? [
                        {
                            label: "Forside",
                            icon: faBorderAll,
                            href: "/warehouse-worker/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/warehouse-worker/overview"),
                        },
                        // {
                        //   label: "Scan",
                        //   icon: faScanner,
                        //   href: "/warehouse-worker/scan/overview",
                        //   isActive: (pathname: string) =>
                        //     pathname.startsWith("/warehouse-worker/scan"),
                        // },
                        // {
                        //   label: "Stock",
                        //   icon: faInventory,
                        //   href: "/warehouse-worker/stock/overview",
                        //   isActive: (pathname: string) =>
                        //     pathname.startsWith("/warehouse-worker/stock/"), // Added a "/" after "stock" to not get it confused with "stock2"
                        // },
                        {
                            label: "Stock²",
                            icon: faWarehouseAlt,
                            href: "/warehouse-worker/stock2/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/warehouse-worker/stock2"),
                        },
                        {
                            label: "Stock Move",
                            icon: faTruckMoving,
                            href: "/warehouse-worker/stock-move/location-overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/warehouse-worker/stock-move"),
                        },
                        {
                            label: "Stock Delete",
                            icon: faTrash,
                            href: "/warehouse-worker/stock-delete/location-overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/warehouse-worker/stock-delete"),
                        },
                        {
                            label: "Customer List",
                            icon: faUsersClass,
                            href: "/warehouse-worker/client-list/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/warehouse-worker/client-list"),
                        },
                        {
                            label: "Audiologist Stock",
                            icon: faCarSide,
                            href: "/warehouse-worker/audiologist-stock/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/warehouse-worker/audiologist-stock/"),
                        },
                        ...(hasAdminReadAccess === false
                            ? [
                                {
                                    label: "Data",
                                    icon: faDatabase,
                                    href: "/mixed/data/overview",
                                    target: "_blank",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/mixed/data"),
                                },
                                {
                                    label: "Lager-notifikationer",
                                    icon: faSensorAlert,
                                    href: "/mixed/stock-notifications/stock-notifications-list",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/mixed/stock-notifications"),
                                },
                                ...(hasStatsAdminReadAccess
                                    ? [
                                        {
                                            label: "Rapport",
                                            icon: faChartLine,
                                            href: "/mixed/stats/report",
                                            isActive: (pathname: string) =>
                                                pathname.startsWith("/mixed/stats/report"),
                                        },
                                        {
                                            label: "Rapport (admin)",
                                            icon: faChartLine,
                                            href: "/admin/stats/admin",
                                            isActive: (pathname: string) =>
                                                pathname.startsWith("/admin/stats/admin"),
                                        },
                                    ]
                                    : []),
                            ]
                            : []),
                        {
                            label: "Stock Tracking",
                            icon: faBoxUsd,
                            href: "/warehouse-worker/stock-tracking/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/warehouse-worker/stock-tracking"),
                        },
                        {
                            label: "Lageroptælling (Admin)",
                            icon: faAbacus,
                            href: "/warehouse-worker/stock-statements/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/warehouse-worker/stock-statements/"),
                        },
                        {
                            label: "Lageroptælling (Central Stock)",
                            icon: faAbacus,
                            href: "/warehouse-worker/stock-statements-shared/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/warehouse-worker/stock-statements-shared"),
                        },
                        // {
                        //     label: "Stock Warnings",
                        //     icon: faAlarmExclamation,
                        //     href: "/warehouse-worker/stock-warnings/overview",
                        //     isActive: (pathname: string) =>
                        //         pathname.startsWith("/warehouse-worker/stock-warnings"),
                        // },
                        // {
                        //     label: "Return Notifications",
                        //     icon: faTruckLoading,
                        //     href: "/warehouse-worker/return-notifications/overview",
                        //     isActive: (pathname: string) =>
                        //         pathname.startsWith("/warehouse-worker/return-notifications"),
                        // },
                        ...(hasAdminReadAccess === false && hasAudiologReadAccess === false
                            ? [
                                ...(staffId !== "016b4d1b2e0b000126e328D24416C1E6" // 016b4d1b2e0b000126e328D24416C1E6 = SINITONE Lager 1
                                    ? [{
                                        label: "Tid",
                                        icon: faUserClock,
                                        href: "/all/time/overview",
                                        isActive: (pathname: string) =>
                                            pathname.startsWith("/all/time"),
                                    }] : []),
                                ...(staffId !== "016b4d1b2e0b000126e328D24416C1E6" // 016b4d1b2e0b000126e328D24416C1E6 = SINITONE Lager 1
                                    ? [{
                                        label: "Control",
                                        icon: faThList,
                                        href: "/mixed/customer-lists/overview",
                                        isActive: (pathname: string) =>
                                            pathname.startsWith("/mixed/customer-lists"),
                                    }] : []),
                                {
                                    label: "Dokumenter",
                                    icon: faFolderOpen,
                                    href: "/all/documents",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/all/documents"),
                                },
                                {
                                    label: "Kollegastatus",
                                    icon: faUsers,
                                    href: "/all/coworker-status",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/all/coworker-status"),
                                },
                                {
                                    label: "Opslag",
                                    icon: faWindowRestore,
                                    href: "/mixed/bulletin-board/bulletin-list",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/mixed/bulletin-board"),
                                },
                                ...(country === "DK"
                                    ? [
                                        {
                                            label: "Calculator",
                                            icon: faCalculator,
                                            href: "/all/calculator",
                                            isActive: (pathname: string) =>
                                                pathname.startsWith("/all/calculator"),
                                        },
                                    ]
                                    : []),
                                ...(country === "DK"
                                    ? [
                                        {
                                            label: "Kundedata",
                                            icon: faServer,
                                            href: "/all/customer-data",
                                            isActive: (pathname: string) =>
                                                pathname.startsWith("/all/customer-data"),
                                        },
                                    ]
                                    : []),
                                // {
                                //     label: "Documents",
                                //     icon: faFolderOpen,
                                //     href: "/warehouse-worker/products",
                                //     isActive: (pathname: string) =>
                                //         pathname.startsWith("/warehouse-worker/products"),
                                // },
                                // {
                                //     label: "Links",
                                //     icon: faLink,
                                //     href: "/warehouse-worker/links",
                                //     isActive: (pathname: string) =>
                                //         pathname.startsWith("/warehouse-worker/links"),
                                // },
                                {
                                    label: "FAQ",
                                    icon: faQuestion,
                                    href: "/warehouse-worker/faqs",
                                    isActive: (pathname: string) =>
                                        pathname.startsWith("/warehouse-worker/faqs"),
                                },
                            ]
                            : []),
                    ]
                    : []),
                ...(hasCustomerContactReadAccess === true
                    ? [
                        {
                            label: "Kundekontakt",
                            icon: faPhoneAlt,
                            href: "/mixed/kundekontakt/oversigt",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/mixed/kundekontakt"),
                        },
                    ]
                    : []),
                ...(hasNoRole === true
                    ? [
                        {
                            label: "Overview",
                            icon: faBorderAll,
                            href: "/no-role/overview",
                            isActive: (pathname: string) =>
                                pathname.startsWith("/no-role/overview"),
                        },
                    ]
                    : []),
                ...[
                    {
                        label: "Telefonliste",
                        icon: faPhone,
                        href: "/all/users",
                        isActive: (pathname: string) =>
                            pathname.startsWith("/all/users"),
                    },
                    {
                        label: "Mine Kontakter",
                        icon: faAddressBook,
                        href: "/all/contact-list",
                        isActive: (pathname: string) =>
                            pathname.startsWith("/all/contact-list"),
                    },
                    // ...(country === "DK"
                    //     ? [
                    //         {
                    //             label: "Calculator",
                    //             icon: faCalculator,
                    //             href: "/all/calculator",
                    //             isActive: (pathname: string) =>
                    //                 pathname.startsWith("/all/calculator"),
                    //         },
                    //     ]
                    //     : []),
                ]
            ],
        }),
        [hasAdminReadAccess, country, hasStatsAdminReadAccess, staffId, hasAudiologReadAccess, hasWarehouseWorkerReadAccess, hasCustomerContactReadAccess, hasNoRole]
    );
};
